import React from 'react';
import { Button } from 'src/shared/components/ui/button';
import { type EnsureOrganisationOutcome, useEnsureOrganisationMutation } from 'src/shared/state/api-slices/organisationEngineSlice';

export type OnboardResult = EnsureOrganisationOutcome | 'failed';

type OnboardButtonProps = {
    customerId: string;
    customerName: string;
    onOnboarded: (customerId: string, result: OnboardResult) => void;
};

const OnboardButton = ({ customerId, customerName, onOnboarded }: OnboardButtonProps) => {
    const [onboard, { isLoading }] = useEnsureOrganisationMutation();

    const onboardResult = async (): Promise<OnboardResult> => {
        try {
            return await onboard({ business_central_id: customerId, name: customerName }).unwrap();
        } catch {
            return 'failed';
        }
    };

    const handleClick = async () => {
        onOnboarded(customerId, await onboardResult());
    };

    return (
        <Button variant='outline' size='mini' aria-label={`Onboard ${customerId}`} disabled={isLoading} onClick={handleClick}>
            Onboard
        </Button>
    );
};

export default OnboardButton;
